"use client";

import Link from "next/link";
import { FadeUp, TextReveal } from "@/components/marketing/animations";
import { useCounterAnimation } from "@/components/marketing/hooks/useCounterAnimation";

export default function FinalCta() {
  const { ref: counterRef, display: counterDisplay } = useCounterAnimation(
    1247,
    2000,
    (val) => val.toLocaleString("fr-FR")
  );

  return (
    <section
      id="cta"
      style={{
        background: "var(--color-mkt-terracotta)",
        padding: "120px 5vw",
        textAlign: "center",
        borderRadius: '32px 32px 0 0',
        marginTop: -32,
        position: 'relative',
        zIndex: 5,
      }}
    >
      <h2
        style={{
          fontFamily: "var(--font-newsreader), Georgia, serif",
          fontStyle: "italic",
          fontSize: "clamp(28px, 4vw, 44px)",
          color: "var(--color-mkt-cream)",
          maxWidth: 700,
          margin: "0 auto 40px",
          lineHeight: 1.3,
        }}
      >
        <TextReveal text="Tout ce que tu ne portes plus vaut mieux qu'un fond de placard." stagger={0.03} />
      </h2>

      <FadeUp delay={0.15}>
        <Link
          href="/login"
          className="mkt-cta-btn"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: "var(--color-mkt-cream)",
            color: "var(--color-mkt-terracotta)",
            padding: "18px 40px",
            borderRadius: 99,
            fontSize: 17,
            fontWeight: 700,
            textDecoration: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          {"Cr\u00e9er ma premi\u00e8re annonce"}
        </Link>
      </FadeUp>

      <FadeUp delay={0.25}>
        <p
          style={{
            marginTop: 32,
            fontSize: 15,
            color: "rgba(253,246,238,0.7)",
          }}
        >
          {"D\u00e9j\u00e0"}{" "}
          <span
            ref={counterRef}
            style={{
              fontWeight: 600,
              color: "var(--color-mkt-cream)",
            }}
          >
            {counterDisplay}
          </span>{" "}
          {"annonces cr\u00e9\u00e9es."}
        </p>
      </FadeUp>
    </section>
  );
}
